export const DEFAULT_ADDRESS_STATE = {
  firstName: '',
  firstNamePronunciation: '',
  lastName: '',
  lastNamePronunciation: '',
  company: '',
  street: '',
  street2: '',
  city: '',
  postalCode: '',
  stateOrProvince: '',
  country: '',
  customerIdNumber: '',
  countryDialInCode: '',
  phone: '',
  birthdate: '',
  nationality: '',
  alerts: [],
}
